import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const postsService = createApi({
    reducerPath: 'postsService',
    baseQuery: baseQueryWithReauth,
    tagTypes: ['allJobs', 'dislikedJobs'],

    endpoints: (builder) => ({
        getAllJobs: builder.query({
            query: ({ search, page, limit = 10 }) => ({
                url: '/jobs/v1/admin-control/all-jobs',
                method: 'GET',
                params: {
                    search,
                    page,
                    limit,
                },
            }),
            providesTags: ['allJobs'],
        }),

        getDislikedJobs: builder.query({
            query: ({ search, page, limit = 10 }) => ({
                url: '/jobs/v1/admin-control/disliked-jobs',
                method: 'GET',
                params: {
                    search,
                    page,
                    limit,
                },
            }),
            providesTags: ['dislikedJobs'],
        }),

        deleteJob: builder.mutation({
            query: (jobId) => ({
                url: `/jobs/v1/admin-control/${jobId}/delete`,
                method: 'DELETE',
            }),
            invalidatesTags: ['allJobs', 'dislikedJobs'],
        }),
    }),
});

export const {
    useGetAllJobsQuery,
    useGetDislikedJobsQuery,
    useDeleteJobMutation,
} = postsService;